
import { Component, ElementRef } from '@angular/core';
import { ICellRendererComp } from 'ag-grid-community';
import { STATUS_OPTION_SERVICE_VALUES } from 'src/app/angular-elements/producer/sep-application-review-dashboard/sep-application-review-grid/enums/sep-application-review-grid.enum';
import { ActionItemRendererParams, DetailObject } from 'src/app/angular-elements/shared/components/ag-grid-cell-renderers/interfaces/ag-grid-cell-renderer.interface';

export interface DetailNotesRendererParams extends ActionItemRendererParams{
  getDetailValues: (params: any) => DetailObject[];
  getNotesValue: (params: any) => string;
}

@Component({
  selector: 'app-ag-detail-notes-renderer',
  templateUrl: './ag-detail-notes-renderer.component.html',
  styleUrls: ['./ag-detail-notes-renderer.component.scss'],
  standalone: false
})

export class AgDetailNotesRendererComponent implements ICellRendererComp {
  eGui: HTMLDivElement;
  notesTextBox: ElementRef;

  private params: DetailNotesRendererParams;
  isEditing: boolean;
  allowEdit: boolean = true;
  detailValues: DetailObject[];
  noteValue: string;
  rowData: any;
  placeholderValue: string;

  constructor(){}

  getGui() {
    return this.eGui;
  }
  
  agInit(params: DetailNotesRendererParams): void {
    this.allowEdit = params.data.status !== STATUS_OPTION_SERVICE_VALUES.SUBMITTED;
    this.params = params;
    this.noteValue = this.params.getNotesValue(this.params);
    this.detailValues = this.params.getDetailValues(this.params);
    this.rowData = params.data as any;
    this.placeholderValue = this.allowEdit ? "Please type notes here..." : "N/A";
  }

  refresh(params: DetailNotesRendererParams): boolean {
    this.params = params;
    this.rowData = params.data as any;
    
    return true;
  }
  
  ngOnDestroy(): void {}

  onStartEditing(): void{
    this.isEditing = true;
  }

  onSaveNotes(notesValue: string): void{
    this.isEditing = false;
    if(this.params.getActionItems(this.rowData)){
      this.params.getActionItems(this.rowData)
      .find(button => button.id === 'saveNotes')
      .callback(this.rowData, this.params, notesValue);
    }
  }
}

